import { lead } from './lead';
import type { Brand } from './types';

export const stellencockpit: Brand = { ...lead, key: 'stellencockpit' };
